module.exports = __webpack_public_path__ + "static/media/panosta-svg-150x150.e466725b.svg";